import Vue from 'vue'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setGooglemapLoader(state, loader) {
    Vue.set(state, 'googlemapLoader', loader)
  },
}



// WEBPACK FOOTER //
// ./src/store/googlemap/mutations.js